import { KeyRequestModel } from './key-request.model';

export class UpdateKeyRequestModel extends KeyRequestModel {
  public newName: string;
}
